
import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  // api:'https://vcontroltfcm.mx/apirest/api/',
  // api:'http://10.196.92.35/apirest/api/',
  // api:'http://localhost:3000/api/',
  api:'https://terniumpesqueria.scvplatform.com/api/',
  // api:'https://www.mbqdatacloud.com/api_demo/api/',
  // api:'https://mbqdatacloud.com/api_volumetricros_linker/api/',


  idleTimeInMinutes: 5,
  logLevel: NgxLoggerLevel.OFF,
  serverLogLevel: NgxLoggerLevel.ERROR
  // api:'http://3.130.135.31:3000/api/'

};
